/** The languages the backoffice is translated into. */
export const SIGNUP_LANGUAGES = ['en', 'fr', 'es', 'ar'] as const;
export type SignupLanguage = (typeof SIGNUP_LANGUAGES)[number];

const supported = (code: string | null | undefined): SignupLanguage | null => {
    const two = String(code || '').trim().slice(0, 2).toLowerCase();
    return (SIGNUP_LANGUAGES as readonly string[]).includes(two) ? (two as SignupLanguage) : null;
};

/**
 * The language "Start for free" opens in: the landing page's `?lang=` when it
 * passes one, else the first of the browser's languages we have, else English.
 * The app itself starts in English and switches once a vendor's settings load,
 * which a signed-out visitor never has — and the choice made here becomes the
 * new account's language (the API stores it from the `locale` it is sent).
 */
export function pickSignupLanguage(search: string, browserLanguages: readonly string[] = []): SignupLanguage {
    const fromUrl = supported(new URLSearchParams(search).get('lang'));
    if (fromUrl) return fromUrl;
    for (const l of browserLanguages) {
        const hit = supported(l);
        if (hit) return hit;
    }
    return 'en';
}
